/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Jun 08 2023
 **/

import styled from "@emotion/styled";

import { Column, Row } from "@/frameworks/designStuff/components";
import { ZIndex } from "@/frameworks/core/commons";

import * as C from "./constant";

export const Wrapper = styled(Column)<{ left: number; zIndex: keyof typeof ZIndex }>`
	position: fixed;
	bottom: 12px;
	left: 12px;
	transform: ${({ left }) => `translateX(${left}px)`};
	max-height: calc(100vh - ${C.HEADER_HEIGHT}px - ${C.GAP * 2}px);
	transition: 0.5s cubic-bezier(0.2, 0, 0, 1);
	z-index: ${({ zIndex }) => ZIndex[zIndex]};
`;

export const EmptyBox = styled.div`
	width: 24px;
	height: 24px;
`;

export const ChattingList = styled(Column)`
	max-height: calc(100% - ${C.ARROW_ICON_HEIGHT}px - ${C.ARROW_ICON_HEIGHT}px);
`;

export const NewMessageDotBadge = styled(Column)`
	position: absolute;
	left: 0;
	top: 0;
`;

export const RemoveMinimizeChatItemBadge = styled(Column)`
	display: none;
	position: absolute;
	top: -4px;
	right: -8px;
`;

export const ListWrapper = styled(Row)`
	position: relative;
	cursor: pointer;
	&:hover {
		.close {
			display: block;
		}
	}
`;
